import { ref } from 'vue'

export const snackbar = ref({
  show: false,
  message: '',
  color: ''
})

export const useSnackbar = () => {
  const showSnackbar = (message: string, color = 'success') => {
    snackbar.value.show = true
    snackbar.value.message = message
    snackbar.value.color = color
  }

  return { snackbar, showSnackbar }
}
